// Module
var code = "<div class=\"content\" data-bind=\"click: action, enable: enable, class: $data.class ,css: { disable: !enable() }\">\r\n  <bp-img class=\"icon\" params=\"iconName: iconName\"></bp-img>\r\n  <div class=\"link-label\" data-bind=\"text: label\"></div>\r\n</div>\r\n";
// Exports
module.exports = code;